<template>
  <footer class="footer">
    <div class="container footer__container">
      <div class="logo footer__logo">
        <img src="../assets/img/logo_lomexin.svg" alt="" />
      </div>
      <p class="footer__item">
        Реклама лікарського засобу <nobr>Ломексин<sup>®</sup></nobr>, капсули вагінальні м’які по 600
        мг<br />
        Р.п. в Україні UA/6094/01/01, термін дії необмежений.<br />
        Категорія відпуску лікарських засобів. Без рецепта.<br />
        Власник реєстраційного посвідчення: Рекордаті Аіленд Лтд, Ірландія.<br />
        Виробник: Каталент Італі С.п.А., Італія<br />
      </p>
      <p class="footer__item">
        <svg
          width="128"
          height="30"
          viewBox="0 0 128 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M128 16.5101H126.03V29.7285H128V16.5101ZM124.96 16.5101H116.47V18.3257H119.73V29.7285H121.717V18.3257H124.944L124.96 16.5101ZM109.44 25.6051L111.851 20.9388L114.314 25.6051H109.491L110.34 27.302H115.315L116.487 29.6097H118.712C118.712 29.6097 114.195 20.7861 111.919 16.3913L105.127 29.6097H107.335L109.457 25.5373L109.44 25.6051ZM99.948 27.9128H97.1122V18.3257H99.931C100.585 18.2869 101.24 18.382 101.856 18.6053C102.472 18.8286 103.035 19.1754 103.512 19.6243C103.989 20.0733 104.369 20.6149 104.628 21.2159C104.888 21.8169 105.022 22.4646 105.022 23.1193C105.022 23.7739 104.888 24.4216 104.628 25.0227C104.369 25.6237 103.989 26.1653 103.512 26.6143C103.035 27.0632 102.472 27.41 101.856 27.6333C101.24 27.8566 100.585 27.9517 99.931 27.9128H99.948ZM99.931 16.5101H95.1085V29.7285H99.931C100.828 29.7739 101.724 29.6366 102.566 29.325C103.408 29.0133 104.178 28.5338 104.829 27.9156C105.48 27.2975 105.998 26.5535 106.352 25.7289C106.706 24.9044 106.889 24.0165 106.889 23.1193C106.889 22.222 106.706 21.3341 106.352 20.5096C105.998 19.6851 105.48 18.9411 104.829 18.323C104.178 17.7048 103.408 17.2253 102.566 16.9136C101.724 16.602 100.828 16.4647 99.931 16.5101ZM85.005 18.3257H89.7597C90.1059 18.2972 90.4543 18.3408 90.7829 18.4536C91.1114 18.5664 91.413 18.7461 91.6686 18.9813C91.9241 19.2165 92.1281 19.5021 92.2676 19.8201C92.4072 20.138 92.4792 20.4814 92.4792 20.8286C92.4792 21.1758 92.4072 21.5191 92.2676 21.8371C92.1281 22.155 91.9241 22.4406 91.6686 22.6758C91.413 22.911 91.1114 23.0907 90.7829 23.2035C90.4543 23.3164 90.1059 23.3599 89.7597 23.3314H85.005L91.5087 29.7285H94.2765L89.6408 25.13H89.9125C90.4789 25.13 91.0397 25.0186 91.563 24.802C92.0863 24.5854 92.5618 24.2679 92.9623 23.8677C93.3628 23.4675 93.6805 22.9923 93.8972 22.4694C94.114 21.9465 94.2255 21.3861 94.2255 20.8201C94.2255 20.2541 94.114 19.6937 93.8972 19.1707C93.6805 18.6478 93.3628 18.1727 92.9623 17.7725C92.5618 17.3723 92.0863 17.0548 91.563 16.8382C91.0397 16.6216 90.4789 16.5101 89.9125 16.5101H83.0353V29.7285H85.005V18.3257ZM75.0204 28.0486C74.0461 28.0352 73.0975 27.7343 72.2939 27.1836C71.4903 26.633 70.8675 25.8572 70.5039 24.9538C70.1403 24.0505 70.0521 23.0599 70.2504 22.1065C70.4486 21.1532 70.9245 20.2798 71.6182 19.596C72.3119 18.9122 73.1924 18.4486 74.1491 18.2635C75.1057 18.0784 76.0957 18.1801 76.9947 18.5557C77.8937 18.9314 78.6614 19.5642 79.2014 20.3747C79.7415 21.1852 80.0296 22.1371 80.0297 23.1108C80.0253 23.7637 79.8922 24.4093 79.638 25.0108C79.3839 25.6123 79.0136 26.1579 78.5485 26.6164C78.0833 27.075 77.5324 27.4374 76.927 27.6831C76.3217 27.9289 75.6738 28.053 75.0204 28.0486ZM75.0204 16.1707C73.6599 16.1875 72.3348 16.6062 71.2119 17.374C70.089 18.1419 69.2187 19.2245 68.7104 20.4857C68.2021 21.7469 68.0786 23.1302 68.3555 24.4614C68.6324 25.7926 69.2973 27.0121 70.2664 27.9664C71.2356 28.9207 72.4657 29.5671 73.8018 29.8242C75.1378 30.0813 76.5202 29.9376 77.7747 29.4112C79.0291 28.8848 80.0997 27.9992 80.8515 26.8659C81.6033 25.7327 82.0027 24.4026 81.9995 23.0429C81.9816 21.2082 81.2373 19.4552 79.9294 18.1674C78.6216 16.8796 76.8565 16.1617 75.0204 16.1707ZM62.9812 16.1707C61.8218 16.1808 60.6837 16.4829 59.6721 17.0491C58.6605 17.6153 57.8082 18.4272 57.194 19.4099C56.5797 20.3925 56.2234 21.5141 56.158 22.6708C56.0925 23.8276 56.3201 24.9821 56.8196 26.0277C57.3191 27.0732 58.0745 27.976 59.0157 28.6525C59.957 29.329 61.0538 29.7573 62.2047 29.8979C63.3556 30.0385 64.5233 29.8867 65.5999 29.4567C66.6765 29.0267 67.6272 28.3323 68.3641 27.4377L67.3452 25.4864C66.8958 26.2438 66.2575 26.8718 65.4926 27.309C64.7277 27.7462 63.8624 27.9776 62.9812 27.9807C62.309 28.0202 61.6359 27.9219 61.0032 27.692C60.3704 27.4621 59.7913 27.1054 59.3015 26.6438C58.8116 26.1822 58.4214 25.6255 58.1546 25.0077C57.8879 24.3899 57.7503 23.7242 57.7503 23.0514C57.7503 22.3786 57.8879 21.7129 58.1546 21.0952C58.4214 20.4774 58.8116 19.9206 59.3015 19.459C59.7913 18.9974 60.3704 18.6407 61.0032 18.4108C61.6359 18.1809 62.309 18.0827 62.9812 18.1221C63.8624 18.1252 64.7277 18.3567 65.4926 18.7939C66.2575 19.2311 66.8958 19.8591 67.3452 20.6165L68.3811 18.6821C67.7198 17.894 66.8934 17.2607 65.9604 16.8267C65.0273 16.3928 64.0103 16.1688 62.9812 16.1707ZM50.6872 23.9592H54.9833V22.1606H48.8533L50.6872 23.9592ZM48.8703 18.2579H54.9833V16.4422H46.8666V29.6606H54.9833V27.845H48.8533V18.2579H48.8703ZM36.7461 18.2579H41.5177C41.8639 18.2293 42.2123 18.2729 42.5409 18.3857C42.8694 18.4986 43.171 18.6782 43.4266 18.9134C43.6822 19.1486 43.8861 19.4342 44.0256 19.7522C44.1652 20.0701 44.2372 20.4135 44.2372 20.7607C44.2372 21.1079 44.1652 21.4513 44.0256 21.7692C43.8861 22.0872 43.6822 22.3728 43.4266 22.608C43.171 22.8432 42.8694 23.0228 42.5409 23.1356C42.2123 23.2485 41.8639 23.2921 41.5177 23.2635H36.7461L43.2497 29.6606H46.0345L41.3818 25.0791H41.6535C42.2438 25.1161 42.8354 25.0319 43.3919 24.8316C43.9483 24.6313 44.4579 24.3192 44.889 23.9146C45.3201 23.51 45.6637 23.0214 45.8986 22.4789C46.1334 21.9365 46.2546 21.3517 46.2546 20.7607C46.2546 20.1697 46.1334 19.5849 45.8986 19.0425C45.6637 18.5 45.3201 18.0114 44.889 17.6068C44.4579 17.2022 43.9483 16.8901 43.3919 16.6898C42.8354 16.4895 42.2438 16.4052 41.6535 16.4422H34.7764V29.6606H36.7461V18.2579Z"
              fill="white"
            />
            <path
              d="M23.8578 20.8033L29.6991 14.9323L14.909 0.0680103H3.12445L23.8578 20.8033ZM1.90735e-05 11.9119L17.9316 29.7626H29.6991L1.90735e-05 0.0510254V11.9119ZM1.90735e-05 29.7626H14.7901L1.90735e-05 15.0171C-0.0169616 19.87 0.0169997 24.7909 1.90735e-05 29.7117V29.7626Z"
              fill="white"
            />
            <g style="mix-blend-mode: multiply" opacity="0.8">
              <path
                d="M0 29.7115L1.59618 28.1504H13.2109L14.7901 29.7115H0Z"
                fill="white"
              />
            </g>
            <path
              opacity="0.4"
              d="M0 29.7117L1.59618 28.1506V16.5442L0 14.9492V29.7117Z"
              fill="white"
            />
            <g style="mix-blend-mode: multiply" opacity="0.8">
              <path
                d="M17.9315 29.7116L0 11.844H1.59618L17.9825 28.1506H28.1369L29.6991 29.7116H17.9315Z"
                fill="white"
              />
            </g>
            <path
              opacity="0.4"
              d="M0 11.8439H1.59618V1.59502L0 0V11.8439Z"
              fill="white"
            />
            <path
              opacity="0.67"
              d="M14.9086 0L14.6029 1.54412H6.26544L3.12402 0H14.9086Z"
              fill="white"
            />
            <g style="mix-blend-mode: multiply" opacity="0.8">
              <path
                d="M6.26544 1.54412L3.12402 0L23.8574 20.7523L29.6987 14.8643L28.4421 13.6086L23.4498 18.6312L6.26544 1.54412Z"
                fill="white"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="128" height="30" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </p>
      <p class="footer__item">
        <strong
          >Перед застосуванням лікарського засобу необхідно проконсультуватися з
          лікарем та обов’язково ознайомитися з
          <span class="footer__link gtm__instructions" @click="openPopup()"
            >інструкцією для медичного застосування лікарського засобу</span
          >
        </strong>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    openPopup() {
      this.$emit("openPopup", "INSTRUCTIONS");
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  padding: 110px 0 105px;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  background: #664689;
  border-radius: 60px 60px 0 0;
  transform: translateY(-60px);

  &__item {
    margin-top: 50px;
    font-size: 12px;
    line-height: 20px;

    &:first-of-type {
      margin-top: 20px;
    }

    &:last-of-type {
      display: flex;
    }

    strong {
      flex-shrink: 0;
      font-weight: bold;
      font-size: 10px;
      line-height: 20px;
      text-align: center;
      text-transform: uppercase;
    }
  }

  &__link {
    // display: inline-block;
    border-bottom: 1px solid;
    cursor: pointer;
  }
}

@media (max-width: 1200px) {
  .footer {
    &__item {
      strong {
        flex-shrink: 1;
      }
    }
  }
}

@media (max-width: 1100px) {
  .footer {
    padding: 80px 0 30px;

    &__item {
      margin-top: 30px;

      strong {
        font-weight: bold;
        font-size: 10px;
        line-height: 20px;
        text-align: center;
        text-transform: uppercase;
      }
    }
  }
}

@media (max-width: 675px) {
  .footer {
    padding: 70px 0 80px;
    border-radius: 40px 40px 0 0;
    transform: translateY(-40px);

    &__item {
      margin-top: 40px;

      strong {
        font-weight: bold;
        font-size: 10px;
        line-height: 20px;
        text-align: center;
        text-transform: uppercase;
      }
    }
  }
}
</style>
